import { render, staticRenderFns } from "./MonthlySalesAndUnitPrice.vue?vue&type=template&id=1f5d31ec&scoped=true&"
import script from "./MonthlySalesAndUnitPrice.vue?vue&type=script&lang=js&"
export * from "./MonthlySalesAndUnitPrice.vue?vue&type=script&lang=js&"
import style0 from "./MonthlySalesAndUnitPrice.vue?vue&type=style&index=0&id=1f5d31ec&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f5d31ec",
  null
  
)

export default component.exports